export const GET_ONBOARDING_DATA = 'GET_ONBOARDING_DATA';
export const POST_ONBOARDING_DATA = 'POST_ONBOARDING_DATA';
export const UPDATE_OWNER_INFO = 'UPDATE_OWNER_INFO';
export const UPDATE_CONTACT_INFO = 'UPDATE_CONTACT_INFO';
export const UPDATE_BUSINESS_DOCS = 'UPDATE_BUSINESS_DOCS';
export const UPDATE_BUSINESS_LOCATION = 'UPDATE_BUSINESS_LOCATION';
export const UPDATE_VERIFICATION_STATUS = 'UPDATE_VERIFICATION_STATUS';
